import React, { useMemo } from "react";
import { useQuery } from "react-query";

import {
  GridCard,
  GridLayout,
  GridHeaderCell,
  GridCell,
} from "./SummaryCardStyled";
import { getRecorderMiniList } from "api/recorderAPI";
import {
  GetRecorderMiniListResponse,
  RecorderMiniListResponse,
} from "api/interfaces/recorderInterface.interface";

type Props = {
  accountId: string;
};

export function SummaryCardRecorder({ accountId }: Props): JSX.Element {
  const { data } = useQuery(
    ["recorderMiniList", accountId],
    () =>
      getRecorderMiniList({
        accountId: accountId,
      }),
    {
      retry: 0,
      refetchOnWindowFocus: false,
      select: (res: GetRecorderMiniListResponse) => res?.result ?? null,
    }
  );

  const rows = useMemo(() => {
    return data ?? [];
  }, [data]);

  if (rows.length === 0) {
    return <></>;
  }

  return (
    <GridCard>
      <GridLayout $columns="120px 140px 60px 60px">
        <GridHeaderCell $colSpan={2}>Type</GridHeaderCell>
        <GridHeaderCell $align="center">Qty</GridHeaderCell>
        <GridHeaderCell $align="center" $noRightBorder>
          Total
        </GridHeaderCell>

        {rows.map((row: RecorderMiniListResponse) => {
          const span = row.items.length;

          return row.items.map((item, idx) => {
            const isFirst = idx === 0;

            return (
              <React.Fragment key={`${row.type}-${item.label}-${idx}`}>
                {isFirst ? (
                  <GridCell $rowSpan={span}>{row.type}</GridCell>
                ) : null}

                <GridCell>{item.label}</GridCell>
                <GridCell $align="center">{item.qty}</GridCell>

                {isFirst ? (
                  <GridCell $rowSpan={span} $align="center" $noRightBorder>
                    {row.totalCount}
                  </GridCell>
                ) : null}
              </React.Fragment>
            );
          });
        })}
      </GridLayout>
    </GridCard>
  );
}
